import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import PATHS from '@/common/paths';

import { SpendPeriodDto } from '../SpendPeriodTracker.types';

export const SPEND_LIMIT_PERIODS_KEY = 'SPEND_LIMIT_PERIODS';

const useGetSpendLimitPeriodsQuery = (id?: string) => {
  const { isLoading, isError, isSuccess, data } = useQuery(
    [SPEND_LIMIT_PERIODS_KEY, id],
    () => api.get<SpendPeriodDto>(PATHS.SPEND_LIMIT_PERIODS(id)),
    {
      enabled: !!id,
    }
  );

  return {
    data: data?.data,
    isLoading,
    isError,
    isSuccess,
  };
};

export default useGetSpendLimitPeriodsQuery;
